import { privateApi } from "./api.interceptor";


class CommandeService {

  getAll = () => privateApi.get('/commandes');
  servieCmd = (id) => privateApi.patch(`/commandes/servir/${id}`);
  rejetCmd = (id) => privateApi.patch(`/commandes/rejeter/${id}`);
  userCmds = (id) => privateApi.get(`/commandes/user_commandes/${id}`);
}

export default new CommandeService;